export const AGENT_SESSION_CLEARED = "agent-session-cleared";

export interface AgentSession {
  docId: string;
  token: string;
  expiresAt: number;
}

let session: AgentSession | undefined;

export const setAgentSession = (docId: string, token: string, expiresInSeconds?: number): void => {
  if (!docId || !token || (expiresInSeconds !== undefined && (!Number.isFinite(expiresInSeconds) || expiresInSeconds <= 0))) {
    throw new Error("Invalid agent session");
  }
  session = {
    docId,
    token,
    expiresAt: expiresInSeconds === undefined ? Number.POSITIVE_INFINITY : Date.now() + expiresInSeconds * 1000,
  };
};

export const getAgentSession = (docId?: string): AgentSession | null => {
  if (session && Number.isFinite(session.expiresAt) && session.expiresAt <= Date.now()) {
    clearAgentSession();
    return null;
  }
  return session && (docId === undefined || session.docId === docId) ? session : null;
};

export const getAgentToken = (docId?: string): string | null => {
  return getAgentSession(docId)?.token ?? null;
};

export const clearAgentSession = (): void => {
  session = undefined;
  if (typeof window !== "undefined") window.dispatchEvent(new Event(AGENT_SESSION_CLEARED));
};

export const agentAuthorization = (docId: string) => {
  const token = getAgentToken(docId);
  if (!token) {
    clearAgentSession();
    throw Object.assign(new Error("Please verify your PIN to continue."), {
      response: { status: 401 },
    });
  }
  return { headers: { Authorization: `Bearer ${token}` } };
};